import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ErrorActions from '../actions/Error';
import Error from '../components/common/Error'

function mapStateToProps(state) {
  return {
    error: state.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    errorActions: bindActionCreators(ErrorActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Error);



// WEBPACK FOOTER //
// ./src/containers/Error.js